import { ReactNode } from 'react';
import { Route } from 'react-router-dom';
///////////////////////////////////////////////////////////////////////////////////
import { routesTypeApp } from './types';
import { RouteType } from './type';
import { PageWrapper } from '@/app/shared/components';

// Fallback component for lazy loading

const generateAppRoutes = (routes: RouteType[]): ReactNode => {
	return routes.map((route, index) => (
		<Route
			index
			path={route.path}
			element={
				<PageWrapper
					state={route.child ? undefined : route.state || undefined}
				>
					{route.element}
				</PageWrapper>
			}
			key={index}
		/>
	));
};

export const appRoutes: ReactNode = generateAppRoutes(routesTypeApp);
